import { LOCATEUS, LOCATEUS_ERROR, LOCATEUS_HIDE_ERROR, LOCATEUS_START_LOADER, LOCATEUS_STOP_LOADER } from "@frameworks/web/redux/interfaces/StaticFooter/iLocateUs";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: undefined,
        isOpen: false,
    },
};
const LocateReducer = (state = initState, action) => {
    switch (action.type) {
        case LOCATEUS:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case LOCATEUS_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case LOCATEUS_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case LOCATEUS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case LOCATEUS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default LocateReducer;
